import { Icon } from 'ui';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import './teacher-tool-card.scss';

const TeacherToolCard = ({ tool, onClick }) => {
  const [isPressed, setIsPressed] = useState(false);

  const handleClick = () => {
    if (tool.available && onClick) {
      onClick(tool);
    }
  };

  const handleMouseDown = () => {
    if (tool.available) {
      setIsPressed(true);
    }
  };

  const handleMouseUp = () => {
    setIsPressed(false);
  };

  const handleMouseLeave = () => {
    setIsPressed(false);
  };

  const getCardClass = () => {
    let className = 'teacher-tool-card';
    if (!tool.available) {
      className += ' teacher-tool-card--disabled';
    } else if (isPressed) {
      className += ' teacher-tool-card--pressed';
    }
    return className;
  };

  return (
    <div className={getCardClass()} onClick={handleClick} onMouseDown={handleMouseDown} onMouseUp={handleMouseUp} onMouseLeave={handleMouseLeave}>
      <div className="teacher-tool-card__icon">
        <Icon name={tool.icon || 'magic'} color={tool.iconColor || '#FFBC34'} size="md" />
      </div>
      <div className="teacher-tool-card__content">
        <h3 className="teacher-tool-card__title">{tool.title}</h3>
        <p className="teacher-tool-card__description">{tool.description}</p>
      </div>
    </div>
  );
};

TeacherToolCard.propTypes = {
  tool: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    icon: PropTypes.string,
    iconColor: PropTypes.string,
    category: PropTypes.string,
    available: PropTypes.bool,
  }).isRequired,
  onClick: PropTypes.func,
};

export default TeacherToolCard;
